import axios from 'axios';

const api = '/api/admins';

export const getAdmin = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getAdmins = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const saveAdmin = assistant => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, assistant);
};

export const updateAdmin = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};
